var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #3e3f41;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_1752",
    "data-name": "\\u7EC4 1752",
    transform: "translate(-94 -1483)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_76",
    "data-name": "\\u77E9\\u5F62 76",
    className: "cls-1",
    width: 48,
    height: 48,
    transform: "translate(94 1483)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_1751",
    "data-name": "\\u7EC4 1751",
    transform: "translate(30.204 1360.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10",
    "data-name": "\\u8DEF\\u5F84 10",
    className: "cls-2",
    d: "M108.51,155.473a1.411,1.411,0,0,0-1.494,1.494v6.572H67.585V134.562h39.426v6.273a1.494,1.494,0,1,0,2.987,0V134.86a3.315,3.315,0,0,0-3.286-3.286h-2.384A7.978,7.978,0,0,0,96.86,125.6H71.767A7.909,7.909,0,0,0,64,133.367v30.171a3.315,3.315,0,0,0,3.286,3.286h39.426A3.315,3.315,0,0,0,110,163.538v-6.572a1.59,1.59,0,0,0-1.488-1.494ZM71.767,128.886H96.86a5.059,5.059,0,0,1,4.182,2.689H67.883A4.253,4.253,0,0,1,71.767,128.886Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_11",
    "data-name": "\\u8DEF\\u5F84 11",
    className: "cls-2",
    d: "M609.741,461.6h-8.066A5.672,5.672,0,0,0,596,467.276a5.493,5.493,0,0,0,5.676,5.676h8.066a5.672,5.672,0,0,0,5.676-5.676A5.493,5.493,0,0,0,609.741,461.6Zm0,8.066h-8.066a2.39,2.39,0,1,1,0-4.78h8.066a2.39,2.39,0,0,1,0,4.78Z",
    transform: "translate(-503.621 -318.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_12",
    "data-name": "\\u8DEF\\u5F84 12",
    className: "cls-2",
    d: "M680,541.494A1.494,1.494,0,1,0,681.494,540,1.491,1.491,0,0,0,680,541.494Z",
    transform: "translate(-583.14 -392.294)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.6056a538a1ebc7c66f3711744e7904af.svg";
export { ForwardRef as ReactComponent };